module.exports = __webpack_public_path__ + "img/2023big7.b842844e.png";